import React from 'react'
import {NavLink} from 'react-router-dom'
import styled from '../Styles/Nav.module.css'
import { Box, Button, Drawer, DrawerBody, DrawerCloseButton, DrawerContent, DrawerHeader, DrawerOverlay, Img, useDisclosure } from '@chakra-ui/react'

// NavLinks
const baseStyle = {
  // color: "black",
  // textDecoration: "none"
};

const activeStyle = {
  // color: "red",
  // textDecoration: "none"
};

const Navbar = ({projectsRef,infoRef,skillRef,contactRef,homeRef}) => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const btnRef = React.useRef()
  
  const handleScroll=(ref)=>{
     window.scrollTo({
      top: ref.offsetTop,
      left: 0,
      behavior: 'smooth',
     })
  }
  return (
    <Box className={styled.nav_container}>
        <Box className={styled.nav_Image}>
          <div>Aniket</div><div>Aniket</div>
        </Box>
    <Box className={styled.nav_Links}>
      
      <NavLink className={styled.links} onClick={()=>{handleScroll(homeRef.current)}}
          style={({ isActive }) => (isActive ? activeStyle : baseStyle)}
          to={'/'}
        >Home</NavLink>
      <NavLink className={styled.links} onClick={()=>{handleScroll(infoRef.current)}}
          style={({ isActive }) => (isActive ? activeStyle : baseStyle)}
          to={'/about'}
        >About </NavLink>
        <NavLink className={styled.links} onClick={()=>{handleScroll(skillRef.current)}}
          style={({ isActive }) => (isActive ? activeStyle : baseStyle)}
          to={'/skills'}
        >Skills</NavLink>
        <NavLink className={styled.links} onClick={()=>{handleScroll(projectsRef.current)}}
          style={({ isActive }) => (isActive ? activeStyle : baseStyle)}
          to={'/projects'}
        >Projects</NavLink>
        <NavLink className={styled.links} onClick={()=>{handleScroll(contactRef.current)}}
          style={({ isActive }) => (isActive ? activeStyle : baseStyle)}
          to={'/contact'}
        >Contact</NavLink>
 
    </Box>
    <Box className={styled.hamIcon}>
     <Img src="https://raw.githubusercontent.com/Aniket-bansal/Aniket-bansal.github.io/main/list.png" ref={btnRef} onClick={onOpen} />
     <Drawer
        isOpen={isOpen}
        placement='right'
        onClose={onClose}
        finalFocusRef={btnRef}
        
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerBody style={{display:"flex",flexDirection:"column",gap:"60px",paddingTop:"100px"}} >
           
           <Button id="hamIcon_sidebar" onClick={onClose}>
           <NavLink className={styled.links} onClick={()=>{handleScroll(homeRef.current)}}
          style={({ isActive }) => (isActive ? activeStyle : baseStyle)}
          to={'/'}
        >Home</NavLink>
           </Button>
      <Button id="hamIcon_sidebar"  onClick={onClose}>
      <NavLink className={styled.links} onClick={()=>{handleScroll(infoRef.current)}}
          style={({ isActive }) => (isActive ? activeStyle : baseStyle)}
          to={'/about'}
        >About </NavLink>
      </Button>
        <Button id="hamIcon_sidebar"  onClick={onClose}>
        <NavLink className={styled.links} onClick={()=>{handleScroll(skillRef.current)}}
          style={({ isActive }) => (isActive ? activeStyle : baseStyle)}
          to={'/skills'}
        >Skills</NavLink>
        </Button>
        <Button id="hamIcon_sidebar"  onClick={onClose}>
        <NavLink className={styled.links} onClick={()=>{handleScroll(projectsRef.current)}}
          style={({ isActive }) => (isActive ? activeStyle : baseStyle)}
          to={'/projects'}
        >Projects</NavLink>
        </Button>
        <Button id="hamIcon_sidebar"  onClick={onClose}>
        <NavLink className={styled.links} onClick={()=>{handleScroll(contactRef.current)}}
          style={({ isActive }) => (isActive ? activeStyle : baseStyle)}
          to={'/contact'}
        >Contact</NavLink>
        </Button>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </Box>
    </Box>
  )
}

export default Navbar